/**
 * ReceivableHelpers
 *
 * Helper functions for receivable (client) statements
 */

/**
 * Check if statement is paid by client
 */
export const isStatementPaid = (statement) => {
    return statement.PaidStatus === 'Paid';
};

/**
 * Check if statement is invoiced
 */
export const isStatementInvoiced = (statement) => {
    return Boolean(statement.InvoiceID);
};

/**
 * Check if statement is posted (invoice is posted)
 */
export const isStatementInvoicePosted = (statement) => {
    return statement.InvoicePosted === 1;
};

/**
 * Check if statement is previsional
 */
export const isStatementPrevisional = (statement) => {
    return ['Option', 'Job'].includes(statement.Status);
};

/**
 * Check if the main fee (not commission or advance)
 */
export const isMainFee = (statement) => {
    return !statement.isCommission && !statement.isClientAdvance;
};

/**
 * Check if transaction has model payment
 */
export const hasModelPayment = (transaction) => {
    return transaction.ModelPaidStatus === 'Paid';
};

/**
 * Get table className based on statement type
 */
export const getTableClassName = (isPrevisional) => {
    let cn = 'statement-table';
    if (isPrevisional) {
        cn += ' statement-table-previsional';
    }
    return cn;
};

/**
 * Get row className based on statement status
 */
export const getRowClassName = (record, isStatementPaid) => {
    let cn = 'statement-row';
    if (isStatementPaid(record)) {
        cn += ' statement-row-paid';
    }
    return cn;
};

/**
 * Filter transactions by search term
 */
export const searchInText = (text, searchTerm) => {
    if (text && text.toLowerCase().includes(searchTerm.toLowerCase())) {
        return true;
    }
    return false;
};

export const filterTransactions = (transactions, searchTerm) => {
    return transactions.filter((transaction) => {
        if (
            searchInText(transaction.Label, searchTerm) ||
            searchInText(transaction.Title, searchTerm) ||
            searchInText(transaction.Description, searchTerm) ||
            (transaction.Project &&
                (searchInText(transaction.Project.Name, searchTerm) ||
                    searchInText(transaction.Project.Description, searchTerm)))
        ) {
            return true;
        }
        return false;
    });
};

